import { TKUITheme } from "tripkit-react/dist/jss/TKUITheme";

const riderCategoriesSettingDefaultStyle = (theme: TKUITheme) => ({
    riderCategory: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        textTransform: 'capitalize',
        flexGrow: 1,
        '& label': {
            marginLeft: '16px'
        }
    },
    readonlyCategories: {
        padding: '0 16px',
        textTransform: 'capitalize'
    },
    disclaimer: {
        ...theme.textColorGray,
        ...theme.textSizeCaption,
        paddingLeft: '15px!important'
    }
});

export default riderCategoriesSettingDefaultStyle;
